<template>
  <div>
    <h1 style="bottom-margin: 20px;">Application Settings</h1>

    <form ref="form" @submit.prevent="save">
      <b-tabs content-class="mt-3">
        <b-tab title="General Settings" active>
          <b-form-group 
                label="Person Search Minimum Score" label-for="person-min-input">
                <b-form-input id="person-min-input" 
                  v-model="$v.properties.personSearchMinScore.$model" 
                  :state="$v.properties.personSearchMinScore.$dirty ? !$v.properties.personSearchMinScore.$error : null"
                  aria-describedby="input-person-min-live-feedback">
                </b-form-input> 
                <b-form-invalid-feedback id="input-person-min-live-feedback">
                  This field must be at less than 5 characters.
                </b-form-invalid-feedback>     
          </b-form-group>

          <b-form-group 
                label="Person Search Maximum Results" label-for="person-max-input">
                <b-form-input id="person-max-input" 
                  v-model="$v.properties.personSearchMaxResults.$model" 
                  :state="$v.properties.personSearchMaxResults.$dirty ? !$v.properties.personSearchMaxResults.$error : null"
                  aria-describedby="input-person-max-live-feedback">
                </b-form-input> 
                <b-form-invalid-feedback id="input-person-max-live-feedback">
                  This field must be at less than 5 characters.
                </b-form-invalid-feedback>     
          </b-form-group>
        </b-tab>

        <b-tab title="Advanced/MNIT Settings">
          <b-form-group 
                label="REDCap Visit Token" label-for="redcap-visit-token-input" invalid-feedback="REDCap Visit Token is required">
                <b-form-input id="redcap-visit-token-input" 
                  v-model="$v.properties.redCapVisitToken.$model" 
                  :state="$v.properties.redCapVisitToken.$dirty ? !$v.properties.redCapVisitToken.$error : null"
                  aria-describedby="input-redcap-visit-token-live-feedback"
                  required>
                </b-form-input> 
                <b-form-invalid-feedback id="input-redcap-visit-token-live-feedback">
                  This is a required field and must be at less than 50 characters.
                </b-form-invalid-feedback>     
          </b-form-group>

          <b-form-group 
                label="REDCap Visitor Token" label-for="redcap-visitor-token-input" invalid-feedback="REDCap Visitor Token is required">
                <b-form-input id="redcap-visitor-token-input" 
                  v-model="$v.properties.redCapVistorToken.$model" 
                  :state="$v.properties.redCapVistorToken.$dirty ? !$v.properties.redCapVistorToken.$error : null"
                  aria-describedby="input-redcap-visitor-token-live-feedback"
                  required>
                </b-form-input> 
                <b-form-invalid-feedback id="input-redcap-visitor-token-live-feedback">
                  This is a required field and must be at less than 50 characters.
                </b-form-invalid-feedback>     
          </b-form-group>

          <b-form-group 
                label="REDCap API URL" label-for="redcap-url-input" invalid-feedback="REDCap URL is required">
                <b-form-input id="redcap-url-input" 
                  v-model="$v.properties.redCapUrl.$model" 
                  :state="$v.properties.redCapUrl.$dirty ? !$v.properties.redCapUrl.$error : null"
                  aria-describedby="input-redcap-url-live-feedback"
                  required>
                </b-form-input> 
                <b-form-invalid-feedback id="input-redcap-url-live-feedback">
                  This is a required field and must be at less than 75 characters.
                </b-form-invalid-feedback>     
          </b-form-group>  
        </b-tab>
      </b-tabs>
    
      <b-button type="submit" variant="primary" :disabled="$v.properties.$invalid">Save</b-button>
      </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { validationMixin } from 'vuelidate'
  import { required, minLength, maxLength} from 'vuelidate/lib/validators'

  axiosRetry(axios, { retries: 3 });

  export default {
    mixins: [validationMixin],
    title:  'Application Settings',
    data: () => ({
      isBusy: false,
      properties: {},
    }),

    validations: {
      properties: {
        redCapVisitToken: {
          required,
          maxLength: 50
        },
        redCapVistorToken: {
          required,
          maxLength: 50
        },
        redCapUrl: {
          required,
          maxLength: 75
        },
        personSearchMinScore: {
          maxLength: 5
        },
        personSearchMaxResults: {
          maxLength: 5
        }
      }
    },
    
    created () {
      this.initialize()
    },

    methods: {
      fetchProperties() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/settings`)
            .then(response => {
                this.properties = response.data
                this.isBusy = false
            })
      },

      initialize () {
          this.isBusy = true
          this.fetchProperties()
      },

      save () {     
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/settings`, this.properties)
          .then(response => {  
            this.$bvToast.toast('Application Settings Saved', {
                title: 'Status',
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'success',
                appendToast: true
              })             
          })
      }
    }
  }
</script>